import React, { Component } from 'react';
import * as XLSX from 'xlsx';
import moment from 'moment';
import {
    Button,
} from 'reactstrap';
import 'moment/locale/pt-br';
import "./invoices/Invoices.css";
import { translateStatus, PaymentMethod, SaleType, CategoryName } from "../utils/pagarme";
import _ from "lodash";

export default class InvoicesXls extends Component {
    formatInvoices() {
        let invoices = this.props.invoices;
        let formatted = [];

        invoices = _.orderBy(invoices, o => new moment(o.dataTransaction), ['asc']);

        for (const order of invoices) {
            for (const product of order.products || []) {
                const invoice = {};

                let amount = 0;
                if (product.ProductPrice) {
                    if (order.description?.toLowerCase() === "casa22_rb_presencial") {
                        amount = product.ProductSale ? (product.ProductSalePrice * 0.65) : (product.ProductPrice * 0.65);
                    } else if (order.description?.toLowerCase() === "gift") {
                        amount = 0;
                    } else {
                        amount = product.ProductSale ? product.ProductSalePrice : product.ProductPrice;
                    }
                }

                Object.assign(invoice, {
                    name: order.customer?.name,
                    descriptionChannel: SaleType(order.description),
                    codeProduct: product.ProductName,
                    categoryProduct: CategoryName(product),
                    colorProduct: product.ProductColor?.colorName,
                    quantityProduct: product.ProductQuantity,
                    sizeProduct: product.ProductSize,
                    status: translateStatus(order.status),
                    statusDelivery: order.tracking?.status,
                    typeDelivery: order.tracking?.type,
                    descriptionDelivery: order.tracking?.description,
                    codeDelivery: order.tracking?.code,
                    dateTransaction: moment(order.dataTransaction).format('DD/MM/YYYY'),
                    methodPayment: PaymentMethod(order.paymentMethod),
                    installments: order.installments,
                    codeOrder: order.code,
                    taxFee: order.delivery?.fee ? (order.delivery.fee / 100).toFixed(2) : '',
                    amount: amount.toFixed(2).toString().replace('.', ','),
                    coupon: order.coupon,
                    email: order.customer?.email,
                    phone: order.customer?.phone_numbers?.[0],
                    dateBirthday: order.customer?.birthday,
                    address: order.delivery?.address
                        ? `Cep: ${order.delivery.address.zipcode}, ${order.delivery.address.street}, ${order.delivery.address.street_number}, Complemento: ${order.delivery.address.complementary}, Bairro: ${order.delivery.address.neighborhood}`
                        : '',
                    city: order.delivery?.address?.city,
                    state: order.delivery?.address?.state?.toUpperCase(),
                    instagram: "",
                    work: "",
                    aboutSvelta: "",
                    observations: order.observation || ""
                });

                formatted.push(invoice);
            }
        }

        return formatted;
    }

    exportToExcel = () => {
        const data = this.formatInvoices();
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Faturas");

        XLSX.writeFile(workbook, "faturas_svelta.xlsx");
    };

    render() {
        // className/children opcionais: a tela de Vendas usa o botão no
        // padrão .cp-btn ("Exportar"); o resto continua com o visual antigo.
        const { className, children } = this.props;
        if (className) {
            return <button type="button" className={className} onClick={this.exportToExcel}>{children || "Baixar planilha"}</button>;
        }
        return <Button
            type="button"
            color="primary"
            className="px-4 download-button" onClick={this.exportToExcel}>Baixar planilha</Button>;
    }
}
